import { render, staticRenderFns } from "./OwnerDocsForm.vue?vue&type=template&id=15975440&scoped=true&"
import script from "./OwnerDocsForm.vue?vue&type=script&lang=js&"
export * from "./OwnerDocsForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerDocsForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OwnerDocsForm.vue?vue&type=style&index=1&id=15975440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15975440",
  null
  
)

export default component.exports